var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCheckSquare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-square-16px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 2.75C3.17862 2.75 3.03025 2.81146 2.92085 2.92085C2.81146 3.03025 2.75 3.17862 2.75 3.33333V12.6667C2.75 12.8214 2.81146 12.9697 2.92085 13.0791C3.03025 13.1885 3.17862 13.25 3.33333 13.25H12.6667C12.8214 13.25 12.9698 13.1885 13.0791 13.0791C13.1885 12.9698 13.25 12.8214 13.25 12.6667V8C13.25 7.58579 13.5858 7.25 14 7.25C14.4142 7.25 14.75 7.58579 14.75 8V12.6667C14.75 13.2192 14.5305 13.7491 14.1398 14.1398C13.7491 14.5305 13.2192 14.75 12.6667 14.75H3.33333C2.7808 14.75 2.2509 14.5305 1.86019 14.1398C1.46949 13.7491 1.25 13.2192 1.25 12.6667V3.33333C1.25 2.7808 1.46949 2.2509 1.86019 1.86019C2.2509 1.46949 2.7808 1.25 3.33333 1.25H10.6667C11.0809 1.25 11.4167 1.58579 11.4167 2C11.4167 2.41421 11.0809 2.75 10.6667 2.75H3.33333ZM15.197 2.13634C15.4899 2.42923 15.4899 2.9041 15.197 3.197L8.53033 9.86366C8.23744 10.1566 7.76256 10.1566 7.46967 9.86366L5.46967 7.86366C5.17678 7.57077 5.17678 7.0959 5.46967 6.803C5.76256 6.51011 6.23744 6.51011 6.53033 6.803L8 8.27267L14.1363 2.13634C14.4292 1.84344 14.9041 1.84344 15.197 2.13634Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-square.1dd21227.svg";
export { ForwardRef as ReactComponent };